import { Injectable } from '@angular/core';
import { FeatureFlagService } from '@galaxy/partner';
import { AppConfigService } from '../core/app-config.service';
import { shareReplay, switchMap, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

export interface AtlasData {
  accountGroupID: string;
  marketID: string;
  partnerID: string;
}

@Injectable()
export class InternalAtlasService {
  public isAtlasEnabled$: Observable<boolean>;

  constructor(private featureFlagService: FeatureFlagService, private configService: AppConfigService) {
    this.isAtlasEnabled$ = this.configService.appConfig.pipe(
      distinctUntilChanged((a, b) => a.partnerId === b.partnerId && a.marketId === b.marketId),
      switchMap((config) =>
        this.featureFlagService.batchGetStatus(config.partnerId, config.marketId, ['business_navigation']),
      ),
      map((flags) => {
        return flags['business_navigation'];
      }),
      shareReplay(1),
    );
  }
}
